import type { JobPortalPaymentResponse } from '@eliadmin/core/src/api/jobportal/orders-api';

export function getJobOfferPaymentReturnUrl(confirmationPath: string) {
  return new URL(confirmationPath, process.env.NEXT_PUBLIC_APP_URL || window.location.origin).href;
}

/** Follow the existing payment API contract, including gateways that require POST. */
export function redirectJobOfferPayment(response: JobPortalPaymentResponse) {
  const redirect = response.redirect;
  const target = redirect?.redirect || response.payment_url;
  if (!target) return;

  if (redirect?.is_form && redirect.method === 'POST') {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = target;
    form.hidden = true;
    for (const [name, value] of Object.entries(redirect.form ?? {})) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }
    document.body.appendChild(form);
    form.submit();
    form.remove();
    return;
  }

  window.location.assign(target);
}
